// extracted by mini-css-extract-plugin
export default {"ratingContainer":"NewUserFeedback-module__ratingContainer--qmFi5 UserFeedback-module__ratingContainer--i0uZJ"};